import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import FeatureCard from '../molecules/FeatureCard';
import Reveal from '../atoms/Reveal';
import { PixMockup } from '../molecules/Mockups';
import { operacao } from '../content/site';

/** Regras de entrega e pagamento. O bloco de Pix aparece ao lado do texto de
 *  abertura, e não dentro de um cartão: é a única regra desta seção que o
 *  cliente VÊ na tela dele, e mostrá-la explica o resto. */
function OperationSection() {
  return (
    <section className="section" id="operacao">
      <Container className="shell">
        <Row className="align-items-start g-4 gy-5 mb-5">
          <Col lg={7}>
            <span className="section-kicker">{operacao.kicker}</span>
            <h2 className="section-title">{operacao.titulo}</h2>
            <p className="section-lead">{operacao.texto}</p>
          </Col>

          <Col lg={5}>
            <Reveal heavy>
              <PixMockup />
            </Reveal>
          </Col>
        </Row>

        <div className="card-grid">
          {operacao.itens.map((item, i) => (
            <Reveal key={item.titulo} stagger={i}>
              <FeatureCard {...item} />
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default OperationSection;
